<div class="tw:px-8 tw:py-6">
    <div class="tw:mb-4">
        <div class="tw:mb-4">
            <h6 class="tw:h6 tw:text-center">{{ 'INVOICE_DISCOUNT_MODAL.title' | translate }}</h6>
        </div>

        @if (form) {
            <form [formGroup]="form" class="tw:flex tw:flex-col tw:items-center tw:justify-center tw:mb-8">
                <div class="tw:flex tw:items-center tw:mb-4 tw:gap-2">
                    <h6>{{ 'INVOICE_DISCOUNT_MODAL.valueToPay' | translate }}</h6>
                    <div class="tw:flex tw:gap-2" [class.animate-pulse]="loadingTotals()" [class.blur-sm]="loadingTotals()">
                        @if (form.value.discountAmountCents) {
                            <h6 class="tw:text-primary-500">
                                {{
                                    (totalsSimulation().totalCentsWithoutDiscount - totalsSimulation().discountAmountCents) / 100 || 0
                                        | merchantCurrency
                                }}
                            </h6>
                        } @else if (form.value.discountPercentage) {
                            <h6 class="tw:text-primary-500">
                                {{
                                    (totalsSimulation().totalCentsWithoutDiscount -
                                        totalsSimulation().totalCentsWithoutDiscount * (totalsSimulation().discountPercentage / 100)) /
                                        100 || 0 | merchantCurrency
                                }}
                            </h6>
                        } @else {
                            <h6 class="tw:text-primary-500">{{ totalsSimulation().totalCentsWithoutDiscount / 100 || 0 | merchantCurrency }}</h6>
                        }
                        @if (form.value.discountPercentage || form.value.discountAmountCents) {
                            <h6 class="tw:text-neutral-500 tw:line-through">
                                {{ totalsSimulation().totalCentsWithoutDiscount / 100 || 0 | merchantCurrency }}
                            </h6>
                        }
                    </div>
                </div>
                <div>
                    <label>{{ 'INVOICE_DISCOUNT_MODAL.discount' | translate }}</label>

                    <div class="tw:flex tw:items-center tw:gap-4">
                        <div class="tw:max-w-28">
                            @if (activeTab === 'discountPercentage') {
                                <app-text-input [hideErrorMessage]="true"
                                    [hasMarginB]="false"
                                    inputType="number"
                                    [submitAttempted]="submitAttempted"
                                    formControlName="discountPercentage"
                                 />
                            } @else if (activeTab === 'discountAmountCents') {
                                <app-text-input [hideErrorMessage]="true"
                                    [hasMarginB]="false"
                                    inputType="number"
                                    [submitAttempted]="submitAttempted"
                                    formControlName="discountAmountCents"
                                 />
                            }
                        </div>
                        <app-tab-bar [(activeTab)]="activeTab" [tabOptions]="tabOptions" (tabChanged)="onTabChanged($event)" />
                    </div>
                </div>
                @if (form.invalid && submitAttempted) {
                    <div class="tw:mt-2 tw:text-sm tw:text-error-500">
                        @if (activeTab === 'discountPercentage') {
                            {{ 'INVOICE_DISCOUNT_MODAL.discountPercentageInvalid' | translate }}
                        } @else if (activeTab === 'discountAmountCents') {
                            {{ 'INVOICE_DISCOUNT_MODAL.discountAmountCentsInvalid' | translate }}
                        }
                    </div>
                }
            </form>
        }
    </div>

    <div class="tw:flex tw:justify-center tw:gap-4">
        <button class="btn btn-md btn-secondary" [disabled]="saving()" (click)="close()">{{ 'GENERAL.cancel' | translate }}</button>
        <button class="btn btn-md btn-primary" [disabled]="saving()" (click)="save()">{{ 'GENERAL.save' | translate }}</button>
    </div>
</div>
